<template>
  <interview
    v-if='interview && noteMap && loaded'
    :interview='interview'
    :interview-competencies='sortedCompetencies'
    :participant='currentParticipant' :exercise='currentExercise'
    :observations='observations' :assessments='assessments'
    :interview-scale='interviewScale' :note-count='noteCount'
    :note-map='noteMap' :tmp-assessments='tmpAssessments' @sync='sync'/>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BusinessLogicObservation from '@/libs/businessLogicObservation';
import ACTIONS from '@/storeActions';
import Interview from '@/components/Interview.vue';

export default {
  name: 'InterviewPage',
  components: { Interview },
  data: () => ({
    noteCount: 0,
    noteIndex: 0,
    noteMap: {
      topLevel: 0,
      icLevel: []
    },
    loaded: false,
    logic: undefined
  }),
  computed: {
    ...mapGetters([
      'currentInterview',
      'currentExercise',
      'currentParticipant',
      'currentObserver'
    ]),
    ...mapState({
      participantId: (state) => state.currentParticipantId,
      exerciseId: (state) => state.currentExerciseId,
      interviewId: (state) => state.currentInterviewId,
      interview: (state) => state.interviews.find((i) => i?.id === state.currentInterviewId),
      observations: (state) => state.observations.filter((x) => x?.participantId === state.currentParticipantId && x?.exerciseId === state.currentExerciseId) || [],
      assessments: (state) => state.assessments.filter((x) => x?.participantId === state.currentParticipantId && x?.observerTeamMemberId === state.user.userId),
      tmpAssessments: (state) => state.tmpAssessments.filter((x) => x?.participantId === state.currentParticipantId && x?.observerTeamMemberId === state.user.userId),
      sortedCompetencies: (state) => {
        const exerciseCompetencies = state.runInfo.exercises.find((x) => x.id === state.currentExerciseId)?.competencies;
        const subjectiveOverallImpression = exerciseCompetencies.find((x) => x.competency.name === 'Subjektiver Gesamteindruck');
        const interviewCompetencies = (state.interviews.find((x) => x.id === state.currentInterviewId)?.interviewCompetencies || []).map((x) => {
          const mappedExercise = exerciseCompetencies.find((ex) => ex.competency.name === x.text);
          return { ...x, exerciseCompetency: mappedExercise };
        })
        if (interviewCompetencies.findIndex((x) => x.text === 'Subjektiver Gesamteindruck') > -1) return interviewCompetencies
        if (interviewCompetencies.length > 0) {
          interviewCompetencies.push({
            customerId: interviewCompetencies[0].customerId,
            hasFreeText: false,
            hasNote: false,
            interviewId: interviewCompetencies[0].interviewId,
            interviewQuestions: [],
            orderIndex: 9999, // hard coded set highest order imaginable
            text: 'Subjektiver Gesamteindruck',
            exerciseCompetency: subjectiveOverallImpression
          })
        }
        return interviewCompetencies
      },
      interviewScale: (state) => {
        const interview = state.interviews.find((x) => x.id === state.currentInterviewId)
        const scale = interview.interviewScale;
        scale.interviewCriterions.sort((a, b) => a.factor - b.factor)
        return scale;
      }
    })
  },
  methods: {
    sync() {
      console.log('syncing')
    }
  },
  mounted() {
    const self = this;
    this.logic = new BusinessLogicObservation(this);
    // Interview Guard
    if (this.participantId && this.exerciseId && !this.interviewId) this.$router.push({ name: 'observation' })
    // Observation, Assessment, Interview Guard
    if (!this.participantId || !this.exerciseId || !this.interviewId) {
      this.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.$i18n.t('Errors.noExerciseSelected'), color: 'error' });
      this.$router.push({ name: 'overview' })
    }

    // Generate interview Structure for next page
    let interviewNoteCount = 0;
    if (this.interview.hasNote) interviewNoteCount++;
    const result = this.interview?.interviewCompetencies?.forEach((ic, icIndex) => {
      if (ic.hasNote) {
        interviewNoteCount++;
        this.noteMap.icLevel.push({ index: icIndex, page: interviewNoteCount });
      } else {
        this.noteMap.icLevel.push({ index: icIndex })
      }
      const result2 = ic?.interviewQuestions?.forEach((iq, iqIndex) => {
        if (iq.hasNote) {
          interviewNoteCount++;
          this.noteMap.icLevel.push({ index: icIndex, qIndex: iqIndex, page: interviewNoteCount })
        } else {
          this.noteMap.icLevel.push({ index: icIndex, qIndex: iqIndex })
        }
      })
    })
    this.noteCount = interviewNoteCount;
    if (this.observations.length < interviewNoteCount) this.logic.createOrExtendNoteStack(interviewNoteCount)
    this.loaded = true
  }
}
</script>

<style scoped>

</style>
